import { render } from "./exclusion-list.vue?vue&type=template&id=7946273c"
import script from "./exclusion-list.vue?vue&type=script&lang=js"
export * from "./exclusion-list.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__